import styled from '@emotion/styled';
import { fromThemeColors, layout, typography } from '@sharefiledev/flow-web';
export const TileContainer = styled.div `
	display: flex;
	flex-direction: column;
	height: 100%;
`;
export const TileHeader = styled.div `
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid ${fromThemeColors('border')};
	padding: ${layout.mediumSpace};
`;
export const TileTitle = styled.div `
	font-size: ${typography.sizes.base};
	font-weight: ${typography.weights.semiBold};
`;
//# sourceMappingURL=Tile.js.map